import React, { useEffect, useState } from "react";
import { Modal, Offcanvas } from "react-bootstrap";

export default function MyModal({
  label,
  className,
  buttonClassName,
  disabled,
  title,
  modalClassName,
  backdropClassName,
  heading,
  children,
  size,
  centered,
  onShow,
  as = "modal",
  show: controlledShow,
  onHide,
  style,
  container,
  initialShow = false,
  fullscreen,
  placement = "end",
}: {
  label?: string | React.ReactNode;
  className?: string;
  buttonClassName?: string;
  disabled?: boolean;
  title?: string;
  modalClassName?: string;
  backdropClassName?: string;
  heading: string | React.ReactNode;
  children:
    | React.ReactNode
    | (({ handleClose }: { handleClose: () => void }) => React.ReactNode);
  size?: "xxl" | "xl" | "sm" | "lg" | undefined;
  centered?: boolean;
  onShow?: () => void;
  as?: "modal" | "offcanvas";
  show?: boolean;
  onHide?: () => void;
  style?: React.CSSProperties;
  container?: HTMLElement | null;
  initialShow?: boolean;
  fullscreen?: true | string | undefined;
  placement?: "start" | "end" | "top" | "bottom";
}) {
  const [show, setShow] = useState(controlledShow ?? initialShow);
  const shouldRenderBody = show;
  const [fullscreenElement, setFullscreenElement] =
    useState<HTMLElement | null>(null);
  useEffect(() => {
    if (controlledShow !== undefined) setShow(controlledShow);
  }, [controlledShow]);

  useEffect(() => {
    const updateFullscreenElement = () => {
      setFullscreenElement(document.fullscreenElement as HTMLElement | null);
    };

    updateFullscreenElement();
    document.addEventListener("fullscreenchange", updateFullscreenElement);
    return () => {
      document.removeEventListener("fullscreenchange", updateFullscreenElement);
    };
  }, []);

  const handleClose = () => {
    setShow(false);
    onHide?.();
  };
  const handleShow = async () => {
    await onShow?.();
    setShow(true);
  };

  const Element = as === "offcanvas" ? Offcanvas : Modal;
  const triggerLabel =
    typeof label === "string" ? label : title || (typeof heading === "string" ? heading : undefined);

  return (
    <div
      className="d-inline-block"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <button
        type="button"
        className={`btn p-0 border-0 h-100 ${buttonClassName}`}
        aria-label={triggerLabel}
        title={title}
        onClick={(e) => {
          handleShow();
          e.stopPropagation();
        }}
        disabled={disabled}
      >
        {label}
      </button>

      <Element
        show={show}
        onHide={handleClose}
        size={size as any}
        enforceFocus={false}
        scrollable
        contentClassName={modalClassName}
        className={className}
        backdropClassName={backdropClassName}
        centered={centered}
        container={container ?? fullscreenElement ?? undefined}
        placement={as === "offcanvas" ? placement : undefined}
        style={as === "offcanvas" ? { width: "600px", ...style } : style}
        fullscreen={fullscreen}
      >
        <Element.Header closeButton>
          <Element.Title>{heading}</Element.Title>
        </Element.Header>
        <Element.Body>
          {shouldRenderBody
            ? typeof children === "function"
              ? children({ handleClose })
              : children
            : null}
        </Element.Body>
      </Element>
    </div>
  );
}
